
import { Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import CookieConsent from './components/feature/CookieConsent';
import ErrorBoundary from './components/base/ErrorBoundary';
import { initGA4, initGTM, trackPageView, trackPerformance } from './lib/analytics';
import { initErrorTracking } from './lib/errorTracking';

function App() {
  useEffect(() => {
    // Initialize error tracking
    initErrorTracking();

    // Initialize Google Analytics 4 (replace with your actual GA4 ID)
    // Uncomment and add your GA4 Measurement ID when ready
    // initGA4('G-XXXXXXXXXX');

    // Initialize Google Tag Manager
    initGTM('GTM-WZJLH86W');

    // Track initial page view
    trackPageView();

    // Track performance metrics
    trackPerformance();
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter basename={__BASE_PATH__}>
        <Suspense
          fallback={
            <div className="min-h-screen bg-white flex items-center justify-center">
              <div className="text-center">
                <div className="inline-block w-16 h-16 border-4 border-[#0A381F] border-t-transparent rounded-full animate-spin mb-4"></div>
                <p className="text-gray-600 text-lg">Loading Ireland Bound...</p>
              </div>
            </div>
          }
        >
          <AppRoutes />
          <CookieConsent />
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
